// used by `store/connection/manager.ts` and `AppConnection.vue`
export enum ConnectionStatus {
  Unknown = 'unknown',
  Connected = 'connected',
  ReadOnlyMode = 'read-only-mode',
  AgentOffline = 'agent-offline',
  NetworkOffline = 'network-offline',
  ServiceOffline = 'service-offline',
}
